import React, { useCallback } from "react";
import styled from "styled-components";
import { Row, Badge, Button, Layout } from "antd";
import { FormattedMessage } from "react-intl";
import { BellOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { history } from "../../store";

import { selectors as NOTIFICATION_SELECTORS } from "../../ducks/nodeNotifications";

import { getBuildDate } from "../../lib/utils/getBuildTime";
import logoUrl from "../../lib/images/logo.png";
import packageJson from "../../../package.json";
import themeColor from "../../lib/style/theme";

import SelectLang from "../SelectLang";
import UserMenu from "../UserMenu";

const { Header: HeaderAnt } = Layout;

const Header = () => {
  const notificationCounter = useSelector(NOTIFICATION_SELECTORS.getCounter);

  const handleNotification = useCallback(() => {
    history.push("/notifications");
  }, []);

  return (
    <StyledHeader className="header">
      <Row>
        <Logo />
        <StyledBuildDate>
          <FormattedMessage id="general.build" defaultMessage="build" />: {getBuildDate(packageJson.buildDate)}
        </StyledBuildDate>
      </Row>
      <StyledOverlay>
        <StyledNotifications>
          <Badge count={notificationCounter} size="small">
            <Button type="primary" shape="circle" icon={<BellOutlined />} onClick={handleNotification} />
          </Badge>
        </StyledNotifications>
        <SelectLang />
        <UserMenu />
      </StyledOverlay>
    </StyledHeader>
  );
};

const StyledBuildDate = styled.span`
  color: ${themeColor.defaultBackground};
`;

const StyledNotifications = styled.span`
  margin: 0 10px;
`;

const StyledHeader = styled(HeaderAnt)`
  position: fixed;
  z-index: 100;
  width: 100%;
  display: flex;
  justify-content: space-between;

  &.ant-layout-header {
    padding-right: 0;
    padding-left: 20px;
  }
`;

const StyledOverlay = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: center;
  align-items: center;
`;

const Logo = styled.div`
  width: 300px;
  height: 64px;
  background: url(${logoUrl});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`;

export default Header;
